/**
 * NavigationBar.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react'; // @ts-ignore

import SquareAndPencilBold from './square.and.pencil.bold.svg'; // @ts-ignore

import XmarkBold from './xmark.bold.svg'; // @ts-ignore

import TrashBold from './trash.bold.svg'; // @ts-ignore

import PencilBold from './pencil.bold.svg'; // @ts-ignore

import PlusBold from './plus.bold.svg';
import './NavigationBar.css';

function Icon(_ref) {
  var src = _ref.src;
  return React.createElement('img', {
    src: src
  });
}

function Button(_ref2) {
  var title = _ref2.title,
      onClick = _ref2.onClick,
      icon = _ref2.icon;
  return React.createElement('button', {
    className: 'heroButton',
    onClick: onClick,
    title: title,
    alt: title
  }, Icon({
    src: icon
  }));
}

function Title(_ref3) {
  var string = _ref3.string,
      key = _ref3.key;
  return React.createElement('span', {
    className: 'channel',
    key: key
  }, string);
}

function NavigationBar(_ref4) {
  var string = _ref4.string,
      _ref4$items = _ref4.items,
      items = _ref4$items === void 0 ? [] : _ref4$items,
      _ref4$key = _ref4.key,
      key = _ref4$key === void 0 ? null : _ref4$key,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? 'navigationBar' : _ref4$className;
  return React.createElement('div', {
    className: className,
    key: key
  }, Title({
    string: string,
    key: 0
  }), React.createElement('ul', {
    key: 1
  }, items.map(function (_ref5, itemKey) {
    var title = _ref5.title,
        onClick = _ref5.onClick,
        icon = _ref5.icon;
    return React.createElement('li', {
      key: itemKey
    }, Button({
      title: title,
      onClick: onClick,
      icon: icon
    }));
  })));
}

export { NavigationBar, SquareAndPencilBold, XmarkBold, TrashBold, PencilBold, PlusBold };